import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// require("./src/video-embeds.js");
require("./src/hero-background.js");
require("./src/holding-footer.js");
require("./src/utilities.js");
// require("./src/menu.js");
// require("./src/header.js");
require("./src/scroll-animations.js");
// require("./src/savings-charts.js");
// require("./src/testimonial-one.js");
// require("./src/resources-carousel.js");
// require("./src/video-autoplay-on-scroll.js");
// require("./src/accordion.js");
// require("./src/forms.js");
// require("./src/leaders-list-toggles.js");
// require("./src/table.js");
// require("./src/blog-post-image-carousels.js");
// require("./src/related-content-carousel.js");
// require("./src/article-carousel.js");
// require("./src/video-courses.js");
// require("./src/case-studies-grid.js");
// require("./src/podcast-episodes-carousel.js");
// require("./src/savings-calculator.js");
// require("./src/post-list-pagination.js");
// require("./src/event-grid.js");
// require("./src/upcoming-webinars-carousel.js");
// require("./src/filters.js");
// require("./src/smooth-scroll-links.js");